import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {UserPermission} from '../constants';
import {type IUserGroupAutoListItem} from '../schema';

/**
 * `getUserGroupAutoList` request params
 * (what is used to send to server)
 */
export interface GetUserGroupAutoListRequestOptions {
	query: string;
	permission?: UserPermission;
}

/**
 * `getUserGroupAutoList` request
 * (what gets sent to the server)
 */
export type GetUserGroupAutoListRequest = [
	GetUserGroupAutoListRequestOptions['query'],
	Required<GetUserGroupAutoListRequestOptions>['permission'],
];

/**
 * `getUserGroupAutoList` response
 * (what comes back from the server)
 */
export type GetUserGroupAutoListResponse =
	SuccessResponse<GetUserGroupAutoListResult>;

/**
 * `getUserGroupAutoList` result
 * (what is utilized from the server response)
 */
export type GetUserGroupAutoListResult = IUserGroupAutoListItem[];

export const getUserGroupAutoListEndpoint = 'getUserGroupAutoList';

/**
 * Autolist groups/users
 * @param fetchParams Fetch params
 */
export const getUserGroupAutoList = async (
	{query, permission = UserPermission.READ}: GetUserGroupAutoListRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetUserGroupAutoListRequest = [query, permission];

	return client
		.post<GetUserGroupAutoListResponse>(
			getUserGroupAutoListEndpoint,
			requestParams,
			{
				signal,
			},
		)
		.then((response) => response.data.result);
};

export default getUserGroupAutoList;
